import {
  parseAsArrayOf,
  parseAsIsoDate,
  parseAsJson,
  parseAsStringLiteral,
} from 'nuqs'
import { z } from 'zod'

const room = z.object({
  adults: z.number().min(1).max(2),
  children: z.number().min(0).max(1),
  infants: z.number().min(0).max(1),
})

const hotels = ['silica', 'retreat'] as const

export const urlParams = {
  dates: parseAsArrayOf(parseAsIsoDate),
  property: parseAsStringLiteral(hotels).withDefault('silica'),
  // eslint-disable-next-line @typescript-eslint/unbound-method
  rooms: parseAsArrayOf(parseAsJson(room.parse)),
}

export type Room = z.infer<typeof room>
